import cookie from 'js-cookie'

/**
 * 通用请求拦截器
 * @param {object} config - Axios 请求配置
 * @returns {object} 修改后的配置
 */
export function commonRequestInterceptor(config) {
  // 为 /koa 和 /amap 等特殊路径动态调整 baseURL
  if (config.url.indexOf('/koa') === 0) {
    config.baseURL = '/'
  } else if (config.url.includes('/amap')) {
    config.baseURL = ''
  }

  // 统一从 cookie 或 localStorage 获取 token
  const token = cookie.get('token') || (typeof window !== 'undefined' ? localStorage.getItem('token') : null)

  // 如果存在 token，则添加到请求头
  if (token && config.url !== '/auth/oauth/token') {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}

/**
 * 通用成功响应拦截器
 * @param {object} response - Axios 响应对象
 * @returns {object} 响应体数据
 */
export function commonResponseInterceptor(response) {
  const { data } = response
  console.log('commonResponseInterceptor', data)
  // 直接返回响应体数据，简化后续处理
  return response.data
}

/**
 * 通用错误处理拦截器
 * @param {object} error - 错误对象
 * @returns {Promise<never>}
 */
export function commonErrorInterceptor(error) {
  console.log('commonErrorInterceptor', error)
  if (error.response) {
    // 请求已发出，但服务器以状态码响应
    console.error(
      `[Axios] Response Error - Status: ${error.response.status}, ` +
        `URL: ${error.config.url}, ` +
        `Message: ${error.response.data?.msg || error.message}`,
    )
  } else if (error.request) {
    // 请求已发出，但没有收到响应
    console.error(`[Axios] No Response - URL: ${error.config.url}, Error: ${error.message}`)
  } else {
    // 设置请求时发生了一些事情，触发了错误
    console.error(`[Axios] Request Setup Error - ${error.message}`)
  }

  // 将错误继续抛出，以便业务代码可以捕获
  return Promise.reject(error)
}
